import { shipmentLegIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

/** A shipment leg as returned over RPC — dates are ISO strings. */
export const OverboxLegDtoSchema = z.object({
  id: shipmentLegIdFormat.schema,
  service: z.enum(["apc", "epg"]),
  carrier: z.enum(["fedex", "ups", "dhl"]),
  fulfillmentCenter: z.string(),
  trackingNumber: z.string(),
  labelUrl: z.string(),
  status: z.enum(["label_purchased", "voided"]),
  trackingStatus: z.enum(["in_transit", "exception", "delivered"]).nullable(),
  purchasedAt: z.string(),
});

/** A first-mile tracking event as returned over RPC. */
export const OverboxTrackingEventDtoSchema = z.object({
  datetime: z.string(),
  message: z.string(),
  status: z.string(),
});

export const OverboxLegParcelDtoSchema = z.object({
  fulfillmentGroupId: z.string(),
  trackerId: z.string(),
  trackingCode: z.string(),
  addedAt: z.string(),
});
